import { FC, Suspense } from 'react';
import { INLINES, MARKS } from '@contentful/rich-text-types';
import cn from 'classnames';
import dynamic from 'next/dynamic';

import { CommonRichText } from 'components/Shared/SharedComponents';
import { RichTextParsersConfig } from 'types/objectTypes';
import classes from 'styles/_commonClasses.module.scss';
import { mapHyperlinkWithAdditionalProps } from 'lib/richTextMappers';

import styles from './styles.module.scss';

import { HintInterface } from '../config/declarations';

const Tooltip = dynamic(() => import('react-tooltip').then((mod) => mod.Tooltip), {
  ssr: false,
});

const getParsersConfig = (): RichTextParsersConfig => ({
  [INLINES.HYPERLINK]: {
    classNames: styles.hintLink,
    mapper: mapHyperlinkWithAdditionalProps({ onClick: (e) => {
      e.stopPropagation();
    } }),
  },
  [MARKS.BOLD]: {
    classNames: classes.textBold,
  },
});

export const Hint: FC<HintInterface> = ({
  isAddToFavoriteHintActive,
  hint,
  className,
  tooltipId,
}) => {
  if (!isAddToFavoriteHintActive || !hint || (!hint.text && !hint.richText)) {
    return null;
  }

  const hintComponent = hint.richText
    ? (
      <CommonRichText
        content={hint.richText!}
        parsersConfig={getParsersConfig()}
      />
    )
    : hint.text;

  return (
    <Suspense fallback={<>{hintComponent}</>}>
      <Tooltip
        delayShow={100}
        delayHide={100}
        openOnClick
        clickable
        isOpen={isAddToFavoriteHintActive}
        className={cn(styles.hint, className)}
        id={tooltipId}
      >
        {hintComponent}
      </Tooltip>
    </Suspense>
  );
};
